<script type="text/jsx">
import Add from './add';
import Trial2paid from './trial2paid';
import AddTrial from './addTrial';
import Edit from './edit';
import BuyNow from './buy-now';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};
    // FREE TRIAL
    if (this.$context.is.add2trial) return <AddTrial {...context} />;
    if (this.$context.is.add2cart) return <Add {...context} />;
    if (this.$context.is.trial2paid) return <Trial2paid {...context} />;
    if (this.$context.is.edit) return <Edit {...context} />;
    return <BuyNow {...context} />;
  },
};
</script>
